"use client";

// OverlayGuard is intentionally a no-op now to avoid interfering with
// interactive layers (map, modals, nav). Left in place for easy re-enable later.
export default function OverlayGuard() {
  return null;
}
